import { FiltersWorshop } from './FiltersWorshop';
import Grid from '@material-ui/core/Grid';
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';
import { shouldReload } from 'utils/state.handlers';
import Snackbar from '@material-ui/core/Snackbar';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BlockIcon from '@material-ui/icons/Block';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow/TableRow';
import { ThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { DetailsWorkshop, Result } from '../Details';
import { getProfile, resetProfile } from 'redux/actions/profile.actions';
import React, { useEffect, useState } from 'react';
import ModalCustom from 'components/Tools/ModalCustom';
import {
  Styles,
  myTheme,
  getModalStyle,
  StyledTableCell,
  StyledTableRow,
  Alert,
} from '../Tools';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import { Workshop, getWorkshopStatus } from 'types/api/responses/workshop';
import { workshopAll } from 'redux/actions/workshop.actions';
import { Chip, Box } from '@material-ui/core';
import { format, isValid } from 'date-fns';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';
import { Loading } from 'components/Tools/Loading';
import { RenderIf } from '../Tools/Utils';

const SIZE = 10,
  INITPAGE = 1;

export const MouseOverPopover = ({ element }: { element: string }) => {
  const classes = Styles();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div
      style={{
        width: 'fit-content',
        justifyContent: 'center',
        display: 'flex',
      }}
      id={'popover'}
    >
      <Paper
        className={classes.paper}
        style={{
          backgroundColor: getWorkshopStatus(element)?.color,
          color: getWorkshopStatus(element)?.color,
          width: 'fit-content',
        }}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        status
      </Paper>
      <Popover
        className={classes.popover}
        classes={{
          paper: classes.paper,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Typography>{getWorkshopStatus(element)?.type}</Typography>
      </Popover>
    </div>
  );
};

function WorkShopList() {
  const classes = Styles();
  const [modalStyle] = useState(getModalStyle(5, 5));
  const [shop, setShop] = useState<Workshop | undefined>();
  const [res, setRes] = useState<Result>(undefined);
  const [minLoadingComplete, setMinLoadingComplete] = useState(false);
  const dispatch = useThunkDispatch();
  const workshop = useTypedSelector((w) => w.workshop);
  const session = useTypedSelector((s) => s.session);
  const [page, setPage] = useState(1);
  const [modalActiveExcel, setmodalActiveExcel] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (workshop.isLoading) {
      setMinLoadingComplete(false);
      timer = setTimeout(() => {
        setMinLoadingComplete(true);
      }, 3000);
    } else if (!workshop.isLoading) {
      const checkAndComplete = () => {
        if (!workshop.isLoading) {
          setMinLoadingComplete(true);
        }
      };

      checkAndComplete();
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [workshop.isLoading]);

  const handleCloseExcel = (_: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setmodalActiveExcel(false);
  };

  useEffect(() => {
    if (shouldReload(workshop)) {
      dispatch(
        workshopAll({
          params: { page: INITPAGE, size: SIZE },
          filterN: { ...workshop.filter },
        }),
      );
    }
  }, [workshop]);

  const translateKind: Record<string, string> = {
    Branch: 'Sucursal',
    Matrix: 'Matriz',
  };

  const isLatestSyncMonth = (meses: number, value?: string | null) => {
    if (!value) return false;
    const fechaSync = new Date(value);
    const now = new Date();
    const diferenciaMeses =
      (now.getFullYear() - fechaSync.getFullYear()) * 12 +
      (now.getMonth() - fechaSync.getMonth());
    return diferenciaMeses >= meses;
  };

  const formatDate = (date: string | null | undefined) => {
    if (!date) return 'N/A';
    const parsedDate = new Date(date);
    if (!isValid(parsedDate)) return date;
    return format(parsedDate, 'dd/MM/yyyy');
  };

  const TableBodyCustom = (
    <TableBody>
      {workshop.workshops.workshops.map((item: Workshop) => {
        return (
          <StyledTableRow key={item.id}>
            <StyledTableCell component="th" scope="row">
              {item.clientAccount
                ? `${item.clientAccount}-${
                    item.kindNumber !== null
                      ? item.kindNumber
                      : item.kind === 'Matrix'
                      ? '0'
                      : '1'
                  }`
                : 'No asignado'}
            </StyledTableCell>
            <StyledTableCell align="center">
              {item.kind && translateKind[item.kind]
                ? translateKind[item.kind]
                : item.kind || 'Ninguna'}
            </StyledTableCell>
            <StyledTableCell align="center">{item.name}</StyledTableCell>
            <StyledTableCell align="center">{item.branchOffice.name}</StyledTableCell>
            <StyledTableCell align="center">{item.branchOffice.zone.name}</StyledTableCell>
            <StyledTableCell align="center">{formatDate(item?.createdAt)}</StyledTableCell>
            <StyledTableCell align="center">{formatDate(item?.lastSync)}</StyledTableCell>
            <StyledTableCell align="center">
              <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                <Paper
                  className={classes.paper}
                  style={{
                    padding: '8px 12px',
                    color: 'white',
                    backgroundColor: '#343c89',
                    cursor: 'pointer',
                    borderRadius: '8px',
                    transition: 'all 0.2s ease',
                  }}
                  onClick={() => handleOpen(item)}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#4a5aaa';
                    e.currentTarget.style.transform = 'scale(1.05)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#343c89';
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                >
                  <VisibilityIcon style={{ color: 'white', fontSize: '20px' }} />
                </Paper>
                <MouseOverPopover element={item.status} />
              </div>
            </StyledTableCell>
            <StyledTableCell align="center">
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {item.active === 'Active' && item.isFullyActive ? (
                  <CheckCircleIcon style={{ color: 'green', marginRight: '8px' }} />
                ) : (
                  <BlockIcon style={{ color: 'gray', marginRight: '8px' }} />
                )}
              </div>
            </StyledTableCell>

            <StyledTableCell align="center">
              {isLatestSyncMonth(12, item?.lastSync) ? (
                <Chip
                  label={`🕒 ${formatDate(item?.lastSync)}`}
                  style={{ backgroundColor: 'red', color: 'white' }}
                />
              ) : (
                <Chip
                  label={`✅ ${formatDate(item?.lastSync)}`}
                  style={{ backgroundColor: 'green', color: 'white' }}
                />
              )}
            </StyledTableCell>
          </StyledTableRow>
        );
      })}
    </TableBody>
  );

  const handleOpen = (clickedShop: Workshop) => {
    dispatch(resetProfile());
    setShop(clickedShop);
    if (clickedShop.clientAccount) {
      dispatch(getProfile(clickedShop.clientAccount));
    }
  };

  const handleClose = () => {
    setShop(undefined);
    setRes(undefined);
  };

  const handleRes = (result: Result) => {
    setRes(result);

    if (result !== 'error') {
      setShop(undefined);
      dispatch(
        workshopAll({ params: { page: INITPAGE, size: SIZE }, filterN: workshop.filter }),
      );
    }
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    dispatch(
      workshopAll({
        params: { page: newPage, size: SIZE },
        filterN: workshop.filter,
      }),
    );
  };

  return (
    <ThemeProvider theme={myTheme}>
      <ModalCustom open={!!shop} onClose={handleClose} className={classes.paperModal}>
        {shop && <DetailsWorkshop shop={shop} onClose={handleRes} />}
      </ModalCustom>
      <div className={classes.divider}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '24px 0',
          }}
        >
          {/* Header */}
          <Box
            style={{
              textAlign: 'center',
              marginBottom: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
            }}
          >
            <HomeRepairServiceIcon style={{ fontSize: '40px', color: '#343c89' }} />
            <Typography
              variant="h3"
              style={{
                margin: 0,
                color: '#343c89',
                fontSize: '2rem',
                fontWeight: 700,
              }}
            >
              Talleres
            </Typography>
          </Box>
          {/* Filters */}
          <Grid item xs={11} style={{ width: '100%', marginBottom: '16px' }}>
            <Paper
              elevation={3}
              style={{
                padding: '16px 24px',
                borderRadius: '12px',
                backgroundColor: 'white',
              }}
            >
              <FiltersWorshop />
            </Paper>
          </Grid>
          <Grid item xs={11} style={{ width: '100%' }}>
            <Paper
              elevation={3}
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
              }}
            >
              <TableContainer style={{ maxHeight: '75vh' }}>
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Cuenta</StyledTableCell>
                      <StyledTableCell align="center">Jerarquía</StyledTableCell>
                      <StyledTableCell align="center">Nombre Comercial</StyledTableCell>
                      <StyledTableCell align="center">Sucursal</StyledTableCell>
                      <StyledTableCell align="center">Gerente Zona</StyledTableCell>
                      <StyledTableCell align="center">Fecha creación</StyledTableCell>
                      <StyledTableCell align="center">Fecha modificación</StyledTableCell>
                      <StyledTableCell align="center">Perfil</StyledTableCell>
                      <StyledTableCell align="center">Estado</StyledTableCell>
                      <StyledTableCell align="center">Sincronizado</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {TableBodyCustom}
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
          <Grid item xs={12} style={{ width: '100%', marginTop: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              {!minLoadingComplete || workshop.isLoading ? (
                <Loading
                  message="Cargando talleres..."
                  subMessage="Por favor espere mientras se cargan los talleres"
                />
              ) : (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    width: '100%',
                  }}
                >
                  <RenderIf condition={Boolean(workshop.workshops.meta?.metrics)}>
                    <div
                      style={{
                        display: 'flex',
                        gap: '16px',
                        flexWrap: 'wrap',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'white',
                        padding: '16px 24px',
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                      }}
                    >
                      <RenderIf
                        condition={(workshop.workshops.meta?.metrics?.active ?? 0) > 0}
                      >
                        <Chip
                          icon={<CheckCircleIcon style={{ color: 'white' }} />}
                          label={`Activos: ${workshop.workshops.meta?.metrics?.active || 0}`}
                          style={{
                            backgroundColor: '#4caf50',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '14px',
                            padding: '8px 4px',
                          }}
                        />
                      </RenderIf>

                      <RenderIf
                        condition={(workshop.workshops.meta?.metrics?.inactive ?? 0) > 0}
                      >
                        <Chip
                          icon={<BlockIcon style={{ color: 'white' }} />}
                          label={`Inactivos: ${
                            workshop.workshops.meta?.metrics?.inactive || 0
                          }`}
                          style={{
                            backgroundColor: '#ff9800',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '14px',
                            padding: '8px 4px',
                          }}
                        />
                      </RenderIf>

                      <RenderIf
                        condition={(workshop.workshops.meta?.metrics?.erased ?? 0) > 0}
                      >
                        <Chip
                          label={`Borrados: ${workshop.workshops.meta?.metrics?.erased || 0}`}
                          style={{
                            backgroundColor: '#f44336',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '14px',
                            padding: '8px 4px',
                          }}
                        />
                      </RenderIf>

                      <RenderIf condition={(workshop.workshops.meta?.metrics?.total ?? 0) > 0}>
                        <Chip
                          label={`Total: ${workshop.workshops.meta?.metrics?.total || 0}`}
                          style={{
                            backgroundColor: '#343c89',
                            color: 'white',
                            fontWeight: 600,
                            fontSize: '14px',
                            padding: '8px 4px',
                          }}
                        />
                      </RenderIf>
                    </div>
                  </RenderIf>

                  <Pagination
                    count={workshop.workshops.meta?.pages}
                    variant="outlined"
                    shape="rounded"
                    page={page}
                    onChange={handleChangePage}
                    style={{
                      backgroundColor: 'white',
                      padding: '12px',
                      borderRadius: '12px',
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    }}
                  />
                </div>
              )}
            </div>
          </Grid>

          <Snackbar
            open={Boolean(res)}
            autoHideDuration={5000}
            onClose={() => setRes(undefined)}
          >
            {res && (
              <Alert onClose={() => setRes(undefined)} severity={res}>
                {res === 'success' ? (
                  <p>Taller actualizado correctamente</p>
                ) : (
                  <p>Error de Actualización</p>
                )}
              </Alert>
            )}
          </Snackbar>
          <Snackbar
            open={modalActiveExcel}
            autoHideDuration={15000}
            onClose={handleCloseExcel}
          >
            {session.isLoading ? (
              <Alert onClose={handleCloseExcel} severity="info">
                <div>Cargando...</div>
              </Alert>
            ) : (
              <div>
                {session.error || workshop.error ? (
                  <Alert onClose={handleCloseExcel} severity="error">
                    <div>
                      ocurrio un error {session.error?.message} {workshop.error?.message}
                    </div>
                  </Alert>
                ) : (
                  <Alert onClose={handleCloseExcel} severity="success">
                    <div>La descarga esta en proceso</div>
                  </Alert>
                )}
              </div>
            )}
          </Snackbar>
        </div>
      </div>
    </ThemeProvider>
  );
}

export { WorkShopList };
